import { Link, useNavigate } from "react-router-dom";
import { Menu, LogIn } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetClose,
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export const MobileMenu = () => {
  const { session } = useAuth();
  const navigate = useNavigate();

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="text-white md:hidden">
          <Menu className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        <div className="flex flex-col gap-4 mt-4">
          <SheetClose asChild>
            <Link to="/" className="text-lg">Venues</Link>
          </SheetClose>
          <SheetClose asChild>
            <Link to="/blog" className="text-lg">Blog</Link>
          </SheetClose>
          {!session && (
            <SheetClose asChild>
              <Button
                variant="default"
                className="w-full"
                onClick={() => navigate("/auth")}
              >
                <LogIn className="h-4 w-4 mr-2" />
                Login
              </Button>
            </SheetClose>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
};